import React from 'react';
import { IconServer, IconExclamationCircle } from './OnboardingIcons';

const ServiceEndpointsForm = ({ data, errors, onUpdate }) => {
  const handleEndpointChange = (endpointKey, value) => {
    onUpdate('infrastructure_endpoints', {
      ...data.infrastructure_endpoints,
      [endpointKey]: value
    });
  };

  // The hint sits with its own field rather than in a legend below the grid.
  // The old "Endpoint Guidelines" panel restated each label ("AAS Discovery:
  // Service discovery endpoint...") under a field already labelled AAS
  // Discovery, so it cost a screen of height and said nothing new.
  const endpointTypes = [
    {
      key: 'AAS Discovery',
      label: 'AAS Discovery',
      hint: 'Finds shells by asset ID',
      placeholder: 'https://discovery.example.com/api/v3.0/lookup/shells'
    },
    {
      key: 'AAS Registry',
      label: 'AAS Registry',
      hint: 'Lists shell descriptors',
      placeholder: 'https://registry.example.com/api/v3.0/shell-descriptors'
    },
    {
      key: 'AAS Repository',
      label: 'AAS Repository',
      hint: 'Serves the shells themselves',
      placeholder: 'https://aas.example.com/api/v3.0/shells'
    },
    {
      key: 'Submodel Registry',
      label: 'Submodel Registry',
      hint: 'Lists submodel descriptors',
      placeholder: 'https://sm-registry.example.com/api/v3.0/submodel-descriptors'
    },
    {
      key: 'Submodel Repository',
      label: 'Submodel Repository',
      hint: 'Serves submodel data',
      placeholder: 'https://sm.example.com/api/v3.0/submodels'
    },
    {
      key: 'Concept Description Repository',
      label: 'Concept Descriptions',
      hint: 'Semantic definitions',
      placeholder: 'https://cd.example.com/api/v3.0/concept-descriptions'
    },
    {
      key: 'DPP Service',
      label: 'DPP Service',
      hint: 'Digital Product Passports',
      placeholder: 'https://dpp.example.com/dpp'
    }
  ];

  const filledCount = endpointTypes.filter(
    (e) => (data.infrastructure_endpoints[e.key] || '').trim()
  ).length;

  return (
    <div className="form-section">
      <div className="section-header">
        <h3>
          <IconServer aria-hidden />
          Infrastructure Endpoints
        </h3>
        {/* The one rule that actually constrains the user, stated once, where
            they are about to act - not in a note box at the bottom. */}
        <p>
          Add the AAS services you run. At least one is required; leave the rest
          blank.
        </p>
      </div>

      {errors.infrastructure_endpoints && (
        <div className="error-message mb-3">
          <IconExclamationCircle aria-hidden />
          {errors.infrastructure_endpoints}
        </div>
      )}

      <div className="endpoints-grid">
        {endpointTypes.map((endpoint) => {
          const value = data.infrastructure_endpoints[endpoint.key] || '';
          return (
            <div
              key={endpoint.key}
              className={`endpoint-card${value.trim() ? ' endpoint-card--filled' : ''}`}
            >
              <label htmlFor={endpoint.key} className="endpoint-label">
                {endpoint.label}
              </label>
              <p className="endpoint-hint">{endpoint.hint}</p>
              <input
                type="url"
                id={endpoint.key}
                className="form-input"
                value={value}
                onChange={(e) => handleEndpointChange(endpoint.key, e.target.value)}
                placeholder={endpoint.placeholder}
              />
            </div>
          );
        })}
      </div>

      {/* Progress against the "at least one" rule, so the requirement resolves
          itself instead of staying an instruction the user has to remember. */}
      <p className="endpoints-count" aria-live="polite">
        {filledCount === 0
          ? 'No endpoints added yet'
          : `${filledCount} of ${endpointTypes.length} endpoints added`}
      </p>
    </div>
  );
};

export default ServiceEndpointsForm;
